import Rule from "../../../../../common/rule";
import FootballState from "../../../../state/football-state";

/**
 * Rule for when the offense catches a ball off the rebound net (Indoor Football).
 * The offense retains possession and can continue the play.
 */
export default class ReboundNetCaughtOffense extends Rule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            fragment.associatedState === FootballState.ReboundNetCaughtOffense
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const { caughtBy, caughtAt } = fragment;

        // Offense retains possession
        if (caughtBy) {
            gameContext.setCurrentPlayerInPossession(caughtBy);
        }
        if (caughtAt || caughtAt === 0) {
            gameContext.setFieldPosition(caughtAt);
        }
    }
}
